export const isEmpty = (value: string | null | undefined) => {
  return value === undefined || value === null || value === "";
};

// field_identifier values — used for suggestion matching and DOM IDs (must match
// TreatmentPlanTemplateField.field_identifier as stored in ReportSuggestion.goal_field)
export const GOAL_FIELD_IDS = {
  GOAL_TITLE: "goal_name",
  STATUS: "status",
  MASTERY_CRITERIA: "mastery_criteria",
  COMPLETION_DATE: "completion_date",
  BASELINE_DATA: "baseline_data",
  BASELINE_DATE: "baseline_date",
  PROJECTED_INTRODUCTION_DATE: "projected_introduction_date",
  GENERALIZATION_CRITERIA: "generalization_criteria",
  ASSESSMENT_TOOL_SOURCE: "assessment_tool_source",
  RATIONALE: "rationale",
  GOAL_ATTAINMENT_SCALE: "goal_attainment_scale",
  GAS_LEVEL_1: "gas_level_1",
  GAS_LEVEL_3: "gas_level_3",
  GAS_LEVEL_4: "gas_level_4",
  GAS_SCORE: "gas_score",
  PROGRESS_SUMMARY: "progress_summary",
} as const;
